import {Checkbox, Col, Radio, Row, Spin, Typography} from 'antd';
import React from "react";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import _, {debounce} from "underscore";
import IRestServiceOptions from "../../../../../../model/interface/api/IRestServiceOptions";
import {connect} from "react-redux";
import selectors from "../../../../../../redux/selectors";
import IRepositoryService from "../../../../../../model/interface/IRepositoryService";
import PresenterBuilder from "../../../../../../views/dataStorage/PresenterBuilder";
import IRestResource from "../../../../../../model/interface/api/IRestResource";
import IFormElementProps from "../../../../../../model/interface/form/IFormElementProps";
import IRestServiceOrders from "../../../../../../model/interface/api/IRestServiceOrders";
import Utils from "../../../../../../utils";
import IField from "../../../../../../model/interface/dataStorage/IField";
import ReactDOMServer from 'react-dom/server'
import ActionButton from "../../../../action/ActionButton";
import {IActionResult} from "../../../../../../model/service/dataStorage/ActionsService";
import store, {IAppState} from "../../../../../../redux/store";
import ProSelect from "../../../../../shared/input/ProSelect";
import DataStorageHelper from "../../../../../../utils/DataStorageHelper";
import ColorSquare from "../../../../../shared/ColorSquare";
import LocaleText from "../../../../settings/dictionary/LocaleText";


interface IProps extends IFormElementProps {
    value?: number,
    onChange?: (key?: number | string | (string | number)[], label?: string | JSX.Element | (string | JSX.Element)[]) => void
    options: IFieldOptions
    findServiceByClassName: (name: string) => IRepositoryService
    field: IField
    getText: (code: string, fallBack?: string, params?: {}) => string
}

interface IState {
    value?: number | string | (string | number)[],
    data: { [x: string]: string | JSX.Element },
    loading: boolean
    options: IFieldOptions
}

const SELECT_ALL = '_all'

class FormFieldContentType extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            data: {},
            loading: false,
            options: props.options
        };
        this.fetch = debounce(this.fetch, 800);
    }

    isUnmounted = false;
    inputRef: any

    componentDidMount() {

        try {
            this.fetchData().then(() => this.selectActive()).then()
        } catch (e) {
            console.error(e)
        }
    }

    autoFocus() {
        const {autoFocus} = this.props.options
        autoFocus && setTimeout(() => this.inputRef?.focus?.(), 100)
    }

    componentWillUnmount() {
        this.isUnmounted = true;
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        const {dependentFields} = this.props.options
        dependentFields?.forEach(field => {
            if (this.props.resource?.[field] !== prevProps.resource?.[field]) {
                this.fetch()
            }
        })
        if (this.props.value !== prevProps.value) {
            this.selectActive()
        }
        this.autoFocus()
    }

    getService() {
        const {options, findServiceByClassName} = this.props

        if (this.props.field && this.props.field.targetEntity) {
            return findServiceByClassName(this.props.field.targetEntity)
        }

        // @deprecated
        return options.contentTypeFullClassName ? findServiceByClassName(options.contentTypeFullClassName) : undefined;
    }


    selectActive() {
        if (this.props.value && !this.isUnmounted) {
            return this.setState({
                value: Utils.parseObjectToIdentifier(this.props.value, 'uuid'),
                loading: false
            });
        }
        this.setState({value: undefined})
    }

    fetch = (value?: string) => {
        const {options} = this.props
        if (options.dependentFields?.length && !value) {
            this.fetchData().then(() => this.selectActive()).then()
        }
        if (value && options.contentTypeAutocompleteMin
            && value.length >= (options.contentTypeAutocompleteMin)
            && options.contentTypeAutocompleteField
            && options.contentTypeAutocompleteMode) {
            const params: IRestServiceOptions = {
                filters:
                    {
                        '0': {
                            value: value,
                            field: options.contentTypeAutocompleteField,
                            type: options.contentTypeAutocompleteMode
                        }
                    }
            }
            this.fetchData(params).then();
        }
    }

    buildOrderCriteria() {
        let orderBy = {} as IRestServiceOrders
        const {options} = this.props
        if (typeof options.contentTypeOrderField === "string") {
            const field = _.findWhere(this.getService()?.getFields() || [], {uuid: options.contentTypeOrderField})
            if (field) {
                orderBy[field.name] = {
                    field: field.name,
                    direction: options.contentTypeOrderDirection as 'ASC' | "DESC" || 'ASC'
                }
            }
        }
        if (Array.isArray(options.contentTypeOrderField)) {
            options.contentTypeOrderField.forEach(fieldName => {
                orderBy[fieldName] = {
                    field: fieldName,
                    direction: options.contentTypeOrderDirection as 'ASC' | "DESC" || 'ASC'
                }
            })
        }
        return orderBy
    }

    fetchData(params?: IRestServiceOptions) {
        const service = this.getService()
        const {options, resource, functions} = this.props
        const {contentTypePresenter, contentTypeFilters} = options
        if (!service || !service.choiceList) {
            console.error('Service is not defined', params)
            return new Promise(() => ([]))
            // throw new Error('Service is not defined')
        }
        const filters = {...params?.filters, ...contentTypeFilters}
        const route = selectors.routes.extractRouteParametersFromUrl(store.getState(), window.location.pathname)
        this.setState({data: {}, loading: true})
        return service.choiceList(contentTypePresenter || service.getDefaultPresenter().name, {
            ...params,
            filters: filters,
            order: this.buildOrderCriteria(),
            route,
            resource: resource ? {
                object: DataStorageHelper.shortenLongStringProperties(DataStorageHelper.buildFormData(resource, functions.getContentType(), undefined, undefined, true)),
                className: functions.getContentType().fullClassName
            } : undefined
        }).then(({results}) => {
            this.setState({
                data: results,
                loading: false
            })
        })
    }

    formatData() {
        const {getText} = this.props
        let {data} = this.state
        if (!data || typeof data !== 'object') {
            return []
        }
        let choices = Object.keys(data).map(id => ({
            key: id,
            label: this.detectCustomPresenter(getText(data[id].toString())),
            value: id,
        }))
        if (this.props.options.processData) {
            choices = this.props.options.processData(choices)
        }

        //TODO label might be null , fix here or in backend ???
        if (!this.props.options.contentTypeOrderField) {
            choices.sort((a: any, b: any) => {
                return (typeof a.label === 'object' ? a.label?.props?.children + "" : a.label + "")
                    .localeCompare(typeof b.label === 'object' ? b.label?.props?.children + "" : b.label + "")
            })
        }

        return choices
    }

    detectCustomPresenter = (value: any) => {
        const {options} = this.props
        const service = this.getService()
        const presenter = options.contentTypePresenter ?
            service?.getPresenter(options.contentTypePresenter) : service?.getDefaultPresenter()
        if (typeof value === "string" && presenter && Object.values(presenter.options).some(v => v && typeof v === "string" && v.includes('@color'))) {
            const colorRegex = /(?:#([0-9a-fA-F]{3}){1,2}|#[0-9a-fA-F]{4}|#[0-9a-fA-F]{8}|rgba?\(\s*(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(?:%?)\s*[, ]?\s*){3}(?:(?:0(?:\.\d+)?|1(?:\.0+)?|[0-9]?\.\d+|[01])\s*\)?|(?:100|[1-9]?[0-9])(?:%)\s*\)?)\)|hsla?\(\s*(?:(?:360|3[0-5][0-9]|[12]?[0-9]{1,2})\s*[, ]?\s*){1}(?:(?:100|[1-9]?[0-9])%\s*[, ]?\s*){2}(?:(?:0(?:\.\d+)?|1(?:\.0+)?|[0-9]?\.\d+|[01])\s*\)?|(?:100|[1-9]?[0-9])(?:%)\s*\)?)\)|(?:(?:red|blue|green|yellow|orange|purple|pink|brown|black|white|gray|grey|cyan|magenta|lime|maroon|navy|olive|silver|teal|violet|indigo|gold|salmon|chocolate|crimson|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|forestgreen|fuchsia|gainsboro|ghostwhite|goldenrod|greenyellow|honeydew|hotpink|indianred|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|limegreen|linen|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|oldlace|olivedrab|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|plum|powderblue|rosybrown|royalblue|saddlebrown|seagreen|sienna|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|thistle|tomato|turquoise|wheat|whitesmoke|yellowgreen|transparent|currentColor|inherit|initial|revert|unset))\b)/gi;

            const result = [];
            let lastIndex = 0;
            let matchCount = 0;

            const allMatches = Array.from(value.matchAll(colorRegex));

            for (const match of allMatches) { // Now iterating over an actual array
                if (match?.index !== undefined){
                    const matchedString = match[0];
                    const matchStartIndex = match.index;
                    const matchEndIndex = match.index + matchedString.length;

                    if (matchStartIndex > lastIndex) {
                        result.push(<span key={`text-${matchCount}-before`}>{value.substring(lastIndex, matchStartIndex)}</span>);
                    }

                    if (CSS.supports('color', matchedString)) {
                        result.push(
                            <ColorSquare key={`color-${matchCount}`} value={matchedString} />
                        );
                    }

                    lastIndex = matchEndIndex;
                    matchCount++;
                }
            }

            if (lastIndex < value.length) {
                result.push(<span key={`text-${matchCount}-after`}>{value.substring(lastIndex)}</span>);
            }

            return result;
        }
        return value
    }

    getLabel(resource: IRestResource) {
        const {options} = this.props
        const service = this.getService()
        const presenter = options.contentTypePresenter ?
            service?.getPresenter(options.contentTypePresenter) : service?.getDefaultPresenter()
        return presenter ? PresenterBuilder.build(presenter, resource, presenter.options || {}) : ''
    }

    handleChange = (option: any) => {
        const {multiple} = this.props.options
        let value: any
        if (multiple) {
            if (!Array.isArray(option)) {
                option = [option]
            }
            value = option ? option.map((oneOption: any) => typeof oneOption === "object" ? oneOption.value : oneOption) : []
            if (value.find((v: string | number) => v === SELECT_ALL)) {
                value = this.formatData().map(d => d.key)
            }
        } else {
            value = (typeof option === "object" && option) ? option.value : option
        }
        this.setState(() => ({
            value,
            loading: false,
        }), this.updateParent)
    };

    handleCheckboxChange(option: any) {

        const id = (typeof option === "object" && option) ? option.value : option
        let currentValue = this.state.value;
        if (typeof currentValue !== 'object') {
            currentValue = [];
        }
        const index = currentValue.indexOf(id)
        if (index >= 0) {
            currentValue.splice(index, 1)
        } else {
            currentValue.push(id)
        }
        this.handleChange(currentValue)
    }

    updateParent = () => {
        const {value, data} = this.state
        this.props.onChange?.(value, Array.isArray(value) ? value.map(v => data[v]) : (value ? data[value] : ''))
    }

    onCreate = (result?: IActionResult) => {
        return new Promise<void>(resolve => {
            const resource = result?.resources[0]
            if (resource) {
                const {value} = this.state
                const {multiple} = this.props.options
                this.setState((state) => {
                    return resource.uuid ? {
                        data: {
                            ...state.data,
                            [resource.uuid]: this.getLabel(resource)
                        }
                    } : {...state}
                }, () => {
                    this.handleChange(multiple && Array.isArray(value) ?
                        [...value, {value: resource.uuid}] : {value: resource.uuid})
                    resolve()
                })
            }
        })
    }

    render() {
        const {loading, value} = this.state
        const {
            style,
            placeholder,
            showClear,
            contentTypeMode,
            disabled,
            multiple,
            contentTypeAllowCreation,
            contentTypeCreationButtonType,
            contentTypeCreationButtonIcon,
            contentTypeCreationButtonText,
            contentTypeCreationAction,
            allowSelectAll,
            contentTypeDropdownMatchSelectWidth,
            contentTypeDropdownHeight
        } = this.props.options
        const props = {style, placeholder, allowClear: showClear}
        const data = this.formatData()
        let widgetMode = contentTypeMode

        if (!widgetMode) {
            widgetMode = 'auto'
        }
        if (widgetMode === "auto") {
            widgetMode = data.length < 6 ? 'radio' : 'select'
        }
        const mode = multiple ? 'multiple' : undefined

        if (data.length === 0 && !loading){
            return <Typography.Text disabled={true}><LocaleText code={'form.field.choice.empty'} fallback={'žádné možnosti k dispozici'}/></Typography.Text>
        }
        const service = this.getService()
        const contentType = service && service.getContentType ? service.getContentType() : null
        const creationAction = contentType && contentType.actions.find(a => a.uuid === contentTypeCreationAction)

        try {
            return <Row><Col className={'flex-grow-1'}>{{
                radio: (
                    <Spin spinning={loading} size={"small"}>
                        {mode === 'multiple' ? (
                            <Checkbox.Group value={Array.isArray(value) ? value : []}>
                                {data.map(item => (
                                    <Checkbox
                                        onChange={() => this.handleCheckboxChange(item.value)}
                                        key={item.value} className={'d-inline-flex align-items-center'}
                                        value={item.value}>
                                        {item.label}
                                    </Checkbox>
                                ))}
                            </Checkbox.Group>
                        ) : (
                            <Radio.Group
                                disabled={disabled}
                                value={value}
                                onChange={(e) => this.handleChange(e.target.value)}
                            >
                                {data.map(value => (
                                    <Radio key={value.value} className={'d-inline-flex align-items-center'}
                                           value={value.value}>{value.label}</Radio>
                                ))}
                            </Radio.Group>
                        )}
                    </Spin>
                ),
                auto: 'Unable to determine mode!',
                select: (
                    <ProSelect
                        {...props}
                        inputRef={ref => this.inputRef = ref}
                        showSearch
                        mode={mode}
                        listHeight={contentTypeDropdownHeight}
                        value={value}
                        disabled={disabled}
                        allowClear={showClear}
                        loading={loading}
                        allowSelectAll={allowSelectAll}
                        notFoundContent={loading ? <Spin size="small"/> : null}
                        filterOption={(input, option) =>
                            Utils.stringContains(ReactDOMServer.renderToString(option?.label as any), input)
                        }
                        options={data}
                        onChange={(value: any) => this.handleChange(value)}
                        onDropdownVisibleChange={open => open && data.length === 0 && this.fetchData()}
                        dropdownMatchSelectWidth={contentTypeDropdownMatchSelectWidth || contentTypeDropdownMatchSelectWidth === undefined}
                        className={'w-100'}
                    />
                ),
                autocomplete: (
                    <ProSelect
                        {...props}
                        disabled={disabled}
                        className={'w-100'}
                        showSearch
                        listHeight={contentTypeDropdownHeight}
                        mode={mode}
                        value={value}
                        allowClear={showClear}
                        notFoundContent={loading ? <Spin size="small"/> : null}
                        loading={loading}
                        allowSelectAll={allowSelectAll}
                        //onSearch={this.fetch}
                        options={data}
                        onChange={this.handleChange}
                        optionFilterProp="children"
                        dropdownMatchSelectWidth={contentTypeDropdownMatchSelectWidth || contentTypeDropdownMatchSelectWidth === undefined}
                        filterOption={(input, option) =>
                            Utils.stringContains(ReactDOMServer.renderToString(option?.children), input)
                        }
                    />
                ),
                default: (
                    <>Invalid mode: {widgetMode}</>
                )
            }[widgetMode]}
            </Col>
                {contentTypeAllowCreation && creationAction && (
                    <ActionButton onFinish={this.onCreate} options={{
                        label: contentTypeCreationButtonText || '',
                        icon: contentTypeCreationButtonIcon,
                        type: contentTypeCreationButtonType,
                        size: 'middle',
                        actionId: creationAction.uuid
                    }} action={creationAction}/>
                )}
            </Row>
        } catch (e) {
            return <>Render failed: {JSON.stringify(e)}</>
        }
    }
}

const mapStateToProps = (store: IAppState) => {
    return {
        findServiceByClassName: (name: string) => selectors.services.findOneByFullClassName(store, name),
        getText: (code: string, fallback?: string, params?: {}) => selectors.dictionary.getMessage(store, code, fallback, params)
    }
}
export default connect(mapStateToProps)(FormFieldContentType)